import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

const legacyStore = (set) => ({
  legacyData: null,
  setLegacyData: (legacyData) => set(() => ({ legacyData })),
  clearLegacyData: () => set(() => ({ legacyData: null })),
});

export const useLegacyStore = create(
  persist(legacyStore, {
    name: "legacyStore",
    storage: createJSONStorage(() => localStorage), // (optional) by default the 'localStorage' is used
  })
);
